import React from 'react';
export function SocialProof() {
  return <section className="bg-brand-dark py-4 px-5" data-id="element-252">
      <div className="max-w-xl mx-auto" data-id="element-253">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-254">
          <StatItem value="+2,000" label="PERSONAS YA LO USAN" data-id="element-255" />
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-256" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-257" />
          <StatItem value="🌎" label="LATINOAMÉRICA" isEmoji data-id="element-258" />
        </div>

        {/* Info badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-5 pt-4 border-t border-gray-800/50" data-id="element-259">
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-260">
            📄 100% digital (PDF)
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-261">
            ⚡ Acceso inmediato
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium text-center" data-id="element-262">
            🧠 Para personas que quieren claridad emocional real
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isEmoji
}: {
  value: string;
  label: string;
  isEmoji?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center py-2" data-id="element-263">
      <div className={`${isEmoji ? 'text-3xl' : 'text-2xl md:text-3xl'} font-black text-brand-yellow mb-1`} data-id="element-264">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-gray-500 font-semibold uppercase tracking-wider leading-tight" data-id="element-265">
        {label}
      </div>
    </div>;
}